import { Component, signal, inject, computed, ViewChild, AfterViewInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './shared/components/navigation/navbar/navbar.component';
import { ToastComponent } from './shared/components/common/toast/toast.component';
import { StorageService } from './shared/services/base/storage.service';
import { SnackbarService } from './shared/services/base/snackbar.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements AfterViewInit {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  private storage = inject(StorageService);
  private snackbarService = inject(SnackbarService);

  protected readonly title = signal('kyc');
  showNavbar = computed(() => this.storage.isAuthenticated());

  ngAfterViewInit(): void {
    this.snackbarService.register(this.toastComponent);
  }
}
